import { configureStore } from '@reduxjs/toolkit'
import themeSlice from './slices/themeSlice'
import ageSlice from './slices/ageSlice'
import wordCounterSlice from './slices/wordCounterSlice'
import imageCompressorSlice from './slices/imageCompressorSlice'
import imageConverterSlice from './slices/imageConverterSlice'
import passwordSlice from './slices/passwordSlice'
import percentageSlice from './slices/percentageSlice'
import ytThumbnailSlice from './slices/ytThumbnailSlice'
import ttsSlice from './slices/ttsSlice'
import qrSlice from './slices/qrSlice'
import jsonSlice from './slices/jsonSlice'
import documentConverterSlice from './slices/documentConverterSlice'

export const store = configureStore({
  reducer: {
    theme: themeSlice,
    age: ageSlice,
    wordCounter: wordCounterSlice,
    imageCompressor: imageCompressorSlice,
    imageConverter: imageConverterSlice,
    password: passwordSlice,
    percentage: percentageSlice,
    ytThumbnail: ytThumbnailSlice,
    tts: ttsSlice,
    qr: qrSlice,
    json: jsonSlice,
    documentConverter: documentConverterSlice,
  },
})

export default store
